// extracted by mini-css-extract-plugin
module.exports = {"outer":"styles_outer__1MWKq","highlighter":"styles_highlighter__zQziP","code":"styles_code__371t_","line-number":"styles_line-number__3Shng"};